<template>
  <b-container>
    <b-row>
      <b-col>
        <b-button
          class="hide-print mt-3 ml-2 float-right"
          size="sm"
          @click.prevent="viewSanction"
          variant="warning"
          v-if="
            ApplicationStatus == 6 ||
            ApplicationStatus == 16 ||
            ApplicationStatus == 8 ||
            ApplicationStatus == 9 ||
            ApplicationStatus == 11
          "
          >Sanction Letter</b-button
        >
        <b-button
          class="hide-print mt-3 ml-2 float-right"
          size="sm"
          @click.prevent="printLoi"
          variant="success"
          v-if="
            ApplicationStatus == 16 ||
            ApplicationStatus == 6 ||
            ApplicationStatus == 8 ||
            ApplicationStatus == 9 ||
            ApplicationStatus == 10 ||
            ApplicationStatus == 11 ||
            ApplicationStatus >= 23 && ApplicationStatus <=29
          "
          >LOI</b-button
        >
        <b-button
          class="hide-print mt-3 ml-2 float-right"
          size="sm"
          @click.prevent="printLoiOld"
          variant="success"
          v-if="ApplicationStatus == 27"
          >PREVIOUS LOI</b-button
        >
        <!-- <b-button
          class="hide-print mt-3 ml-2 float-right"
          size="sm"
          @click.prevent="extendLoi"
          variant="success"
          v-if="(ApplicationStatus==10 || ApplicationStatus==23) && (RoleID==3 || RoleID==4 || RoleID==6)"
        >Extend LOI</b-button>-->
        <b-button
          class="hide-print mt-3 ml-2 float-right"
          size="sm"
          variant="info"
          @click="print"
          >Print Profile</b-button
        >
        <b-button
          class="hide-print mt-3 ml-2 float-right"
          @click.prevent="goback"
          variant="secondary"
          size="sm"
          >BACK</b-button
        >
      </b-col>
    </b-row>
    <div id="printme">
      <div class="application-view">
        <div class="reg-form-box">
          <div class="reg-form-body">
            <b-container class="bv-example-row">
              <b-row>
                <b-col offset="1">
                  <h5 class="reg-form-title text-primary ml-4">
                    Application No:
                    {{ personalDetails.LoanApplication[0].LoanApplicationNo }}
                  </h5>
                </b-col>
              </b-row>
              <b-row>
                <b-col cols="8" offset="1">
                  <b-container class="bv-example-row">
                    <h5 class="reg-form-title text-primary">
                      Personal Details
                      <b-button
                        v-if="RoleID == 0"
                        size="sm"
                        variant="warning"
                        class="ml-3 hide-print"
                        @click="openPersonalEditModal"
                      >Edit Personal Details</b-button>
                    </h5>
                    <table
                      class="profile-table table-3x"
                      style="margin-left: 0"
                    >
                      <tbody>
                        <tr>
                          <td colspan="3">
                            <span class="bold">Applicant Name:</span>
                            {{ personalDetails.FirstName }}
                            {{ personalDetails.MiddleName }}
                            {{ personalDetails.LastName }}
                          </td>
                        </tr>
                        <tr>
                          <td>
                            <span class="bold">Date Of Birth:</span>
                            {{ personalDetails.DOB }}
                          </td>
                          <td>
                            <span class="bold">Aadhar Id:</span>
                            {{ personalDetails.AdharNo }}
                          </td>
                          <td>
                            <span class="bold">PAN No.:</span>
                            {{ personalDetails.PanCardNo }}
                          </td>
                        </tr>
                        <tr>
                          <td>
                            <span class="bold">Gender:</span>
                            <span v-if="personalDetails.Gender">Male</span>
                            <span v-else>Female</span>
                          </td>
                          <td>
                            <span class="bold">Email:</span>
                            {{ personalDetails.EmailID }}
                          </td>
                          <td>
                            <span class="bold">Mobile No.:</span>
                            {{ personalDetails.MobileNo }}
                          </td>
                        </tr>
                        <tr>
                          <td>
                            <span class="bold">Married Status:</span>
                            <span v-if="personalDetails.MaritalStatus"
                              >Married</span
                            >
                            <span v-else>Unmarried</span>
                          </td>
                          <td>
                            <span class="bold">Nationality:</span>
                            <span v-if="personalDetails.Nationality"
                              >Indian</span
                            >
                            <span v-else>Non-Indian</span>
                          </td>
                          <td>
                            <span class="bold">Maharashtra Domicile:</span>
                            <span v-if="personalDetails.Domiciled">Yes</span>
                            <span v-else>No</span>
                          </td>
                        </tr>
                        <tr>
                          <td>
                            <span class="bold">Ration Card:</span>
                            <span>{{ personalDetails.RationCardNo }}</span>
                          </td>
                          <td>
                            <span class="bold">Family Income:</span>
                            <span>{{ personalDetails.FamilyIncome }}</span>
                          </td>
                          <td></td>
                        </tr>
                        <tr>
                          <td colspan="3">
                            <span class="bold">Caste:</span>
                            <span>{{ personalDetails.CasteName }}</span>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </b-container>
                </b-col>
                <b-col cols="2">
                  <b-container class="bv-example-row">
                    <b-row>
                      <b-col>
                        <img
                          style="width: 120px; height: auto"
                          :src="
                            getImgUrl(
                              personalDetails.UserLoanDocuments.PhotoPath
                            )
                          "
                        />
                      </b-col>
                    </b-row>
                    <!-- <b-row>
                      <b-col>
                        <img
                          style="width:120px;height:auto"
                          :src="getImgUrl(personalDetails.UserLoanDocuments.SignaturePath)"
                        >
                      </b-col>
                    </b-row>-->
                  </b-container>
                </b-col>
              </b-row>
            </b-container>
          </div>
        </div>
      </div>

      <!-- ******** -->
      <div class="reg-form-box">
        <div class="reg-form-body">
          <b-container class="bv-example-row">
            <b-row>
              <b-col cols="8" offset="1">
                <b-container class="bv-example-row">
                  <h5 class="reg-form-title text-primary">Address Details</h5>

                  <table class="profile-table table-3x" style="margin-left: 0">
                    <tbody>
                      <tr>
                        <td>
                          <span class="bold">House No:</span>
                          {{ personalDetails.CorrespondenceAddress.HouseNo }}
                        </td>
                        <td>
                          <span class="bold">Building No:</span>
                          {{ personalDetails.CorrespondenceAddress.BuildingNo }}
                        </td>
                        <td>
                          <span class="bold">Landmark:</span>
                          {{ personalDetails.CorrespondenceAddress.Landmark }}
                        </td>
                      </tr>
                      <tr>
                        <td>
                          <span class="bold">Village:</span>
                          {{ personalDetails.CorrespondenceAddress.Village }}
                        </td>
                        <td>
                          <span class="bold">Taluka:</span>
                          {{ personalDetails.CorrespondenceAddress.TalukaName }}
                        </td>
                        <td>
                          <span class="bold">District:</span>
                          {{
                            personalDetails.CorrespondenceAddress.DistrictName
                          }}
                        </td>
                      </tr>
                      <tr>
                        <td>
                          <span class="bold">Post:</span>
                          {{ personalDetails.CorrespondenceAddress.Post }}
                        </td>
                        <td>
                          <span class="bold">State:</span>
                          {{ personalDetails.CorrespondenceAddress.StateName }}
                        </td>
                        <td>
                          <span class="bold">Pincode:</span>
                          {{ personalDetails.CorrespondenceAddress.Pincode }}
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </b-container>
              </b-col>
            </b-row>
          </b-container>
        </div>
      </div>
      <!-- family details starts here -->
      <div class="reg-form-box">
        <div class="reg-form-body">
          <b-container class="bv-example-row">
            <b-row>
              <b-col cols="3"></b-col>
              <b-col cols="9" offset="1">
                <b-container class="bv-example-row">
                  <h5 class="reg-form-title text-primary">Family Details</h5>
                  <table
                    class="profile-table info-table"
                    style="margin-left: 0"
                  >
                    <tbody>
                      <tr>
                        <th class="bold">Full Name</th>
                        <th class="bold">Gender</th>
                        <!-- <th class="bold">Date of Birth</th> -->
                        <th class="bold">Age (Yrs)</th>
                        <th class="bold">Relation Ship</th>
                      </tr>
                      <tr
                        v-for="member in personalDetails.UserFamily"
                        :key="member.FamilyID"
                      >
                        <td>{{ member.FullName }}</td>
                        <td v-if="member.Gender">Male</td>
                        <td v-else>Female</td>
                        <!-- <td>{{member.DOBstr}}</td> -->
                        <td>{{ member.Age }}</td>
                        <td>{{ member.ReletionshipName }}</td>
                      </tr>
                    </tbody>
                  </table>
                </b-container>
              </b-col>
            </b-row>
          </b-container>
        </div>
      </div>

      <!-- family details ends here -->

      <!-- <div class="reg-form-box" style="">
        <div class="reg-form-body">
          <b-container class="bv-example-row">
            <b-row>
              <b-col cols="8" offset="1">
                <b-container class="bv-example-row">
                  <h5 class="reg-form-title text-primary">Bank Details</h5>

                  <table class="profile-table">
                    <tbody>
                      <tr>
                        <td><span class="bold">Bank Accept: </span>{{personalDetails.UserBankDetails.BankAccept}}</td>
                        <td><span class="bold">Bank Name: </span>{{personalDetails.UserBankDetails.BankName}}</td>
                        <td><span class="bold">Branch Name: </span>{{personalDetails.UserBankDetails.BranchName}}</td>
                      </tr>
                      <tr>
                        <td><span class="bold">City: </span>{{personalDetails.UserBankDetails.City}}</td>
                        <td><span class="bold">Comment: </span>{{personalDetails.UserBankDetails.Comment}}</td>
                      </tr>
                    </tbody>
                  </table>
                </b-container>
              </b-col>

            </b-row>
          </b-container>
        </div>
      </div>-->

      <!-- bank account start here -->
      <div class="reg-form-box" style>
        <div class="reg-form-body">
          <b-container class="bv-example-row">
            <b-row>
              <b-col cols="8" offset="1">
                <b-container class="bv-example-row">
                  <h5 class="reg-form-title text-primary">Bank Account</h5>
                  <table class="profile-table" style="margin-left: 0">
                    <tbody>
                      <tr>
                        <td>
                          <span class="bold">Bank Account No:</span>
                          {{ personalDetails.UserBankAccount.BankAccountNo }}
                        </td>
                        <td>
                          <span class="bold">Bank IFSC Code:</span>
                          {{ personalDetails.UserBankAccount.BankIfscCode }}
                        </td>
                        <td>
                          <span class="bold">Bank Name:</span>
                          {{ personalDetails.UserBankAccount.BankName }}
                        </td>
                      </tr>
                      <tr>
                        <td>
                          <span class="bold">Branch Name:</span>
                          {{ personalDetails.UserBankAccount.BranchName }}
                        </td>
                        <td>
                          <span class="bold">City:</span>
                          {{ personalDetails.UserBankAccount.City }}
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </b-container>
              </b-col>
            </b-row>
          </b-container>
        </div>
      </div>

      <!-- bank account ends here -->
      <div class="reg-form-box" style>
        <div class="reg-form-body">
          <b-container class="bv-example-row" v-if="this.LoanType == 1">
            <b-row>
              <b-col cols="8" offset="1">
                <b-container class="bv-example-row">
                  <h5 class="reg-form-title text-primary">
                    Lending Loan Details
                    <b-button
                      v-if="RoleID == 0"
                      size="sm"
                      variant="warning"
                      class="ml-3 hide-print"
                      @click="openLendingLoanEditModal"
                    >Edit Lending Loan</b-button>
                  </h5>

                  <table class="profile-table" style="margin-left: 0">
                    <tbody>
                      <tr>
                        <td>
                          <span class="bold">Organization Name:</span>
                          {{
                            personalDetails.UserLendingLoanDetails
                              .OrganizationName
                          }}
                        </td>
                        <td>
                          <span class="bold">Organization Address:</span>
                          {{
                            personalDetails.UserLendingLoanDetails
                              .OrganizationAddress
                          }}
                        </td>
                      </tr>
                      <tr>
                        <td>
                          <span class="bold">Product From Organization:</span>
                          {{
                            personalDetails.UserLendingLoanDetails
                              .ProductfromOrganization
                          }}
                        </td>
                        <td>
                          <span class="bold">Amount From Bank:</span>
                          {{
                            personalDetails.UserLendingLoanDetails
                              .AmountFromBank
                          }}
                        </td>
                      </tr>
                      <tr>
                        <td>
                          <span class="bold">Bank Name:</span>
                          {{ personalDetails.UserLendingLoanDetails.BankName }}
                        </td>
                        <td>
                          <span class="bold">Branch:</span>
                          {{ personalDetails.UserLendingLoanDetails.Branch }}
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </b-container>
              </b-col>
            </b-row>
          </b-container>
          <b-container class="bv-example-row" v-if="this.LoanType == 3">
            <b-row>
              <b-col cols="8" offset="1">
                <b-container class="bv-example-row">
                  <h5 class="reg-form-title text-primary">
                    Lending Loan Details
                    <b-button
                      v-if="RoleID == 0"
                      size="sm"
                      variant="warning"
                      class="ml-3 hide-print"
                      @click="openLendingLoanEditModal"
                    >Edit Lending Loan</b-button>
                  </h5>

                  <table class="profile-table" style="margin-left: 0">
                    <tbody>
                      <tr>
                        <td>
                          <span class="bold">Institute Name:</span>
                          {{
                            personalDetails.UserLendingLoanDetails
                              .OrganizationName
                          }}
                        </td>
                        <td>
                          <span class="bold">Institute Address:</span>
                          {{
                            personalDetails.UserLendingLoanDetails
                              .OrganizationAddress
                          }}
                        </td>
                      </tr>
                      <tr>
                        <td>
                          <span class="bold">Course Name:</span>
                          {{
                            personalDetails.UserLendingLoanDetails
                              .ProductfromOrganization
                          }}
                        </td>
                        <td>
                          <span class="bold">Amount From Bank:</span>
                          {{
                            personalDetails.UserLendingLoanDetails
                              .AmountFromBank
                          }}
                        </td>
                      </tr>
                      <tr>
                        <td>
                          <span class="bold">Bank Name:</span>
                          {{ personalDetails.UserLendingLoanDetails.BankName }}
                        </td>
                        <td>
                          <span class="bold">Branch:</span>
                          {{ personalDetails.UserLendingLoanDetails.Branch }}
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </b-container>
              </b-col>
            </b-row>
          </b-container>
        </div>
      </div>

      <div class="reg-form-box" style>
        <div class="reg-form-body">
          <b-container class="bv-example-row">
            <b-row>
              <b-col cols="8" offset="1">
                <b-container class="bv-example-row">
                  <h5 class="reg-form-title text-primary">
                    Documents Uploaded
                  </h5>
                  <table class="profile-table doc-table" style="margin-left: 0">
                    <tr>
                      <th>Sr No</th>
                      <th>Document Type</th>
                      <th>Value</th>
                      <th>Link</th>
                    </tr>
                    <tr>
                      <td>01.</td>
                      <td>Photo</td>
                      <td></td>
                      <td>
                        <span
                          v-if="
                            personalDetails.UserLoanDocuments.PhotoPath == ''
                          "
                          >Not Uploaded</span
                        >
                        <span
                          v-if="
                            personalDetails.UserLoanDocuments.PhotoPath != ''
                          "
                        >
                          <a
                            target="_blank"
                            :href="
                              getImgUrl(
                                personalDetails.UserLoanDocuments.PhotoPath
                              )
                            "
                            >View</a
                          >
                        </span>
                      </td>
                    </tr>

                    <tr>
                      <td>02.</td>
                      <td>Birth Certificate</td>
                      <td>
                        <span v-if="!editList.eDOB">
                          {{ personalDetails.DOB }}
                          <b-btn
                            class="float-right"
                            variant="link"
                            @click="EditField('eDOB')"
                          >
                            <i
                              class="fa fa-edit"
                              style="font-size: 14px; color: red"
                            ></i>
                          </b-btn>
                        </span>
                        <span v-if="editList.eDOB">
                          <!-- <b-input-group> -->
                          <!-- <b-form-input type="date" v-model ="personalDetails.DOB"></b-form-input> -->
                          <date-picker
                            v-model="DOB"
                            :state="validateAge"
                            format="DD-MM-YYYY"
                            lang="en"
                            required
                            size="small"
                          ></date-picker>
                          <!-- <b-input-group-append> -->
                          <b-btn
                            size="sm"
                            @click="EditField('eDOB')"
                            variant="primary"
                          >
                            <i
                              class="fa fa-save"
                              style="color: white; font-size: 16px"
                            ></i>
                          </b-btn>
                          <b-btn
                            size="sm"
                            @click="CloseField('eDOB')"
                            variant="info"
                          >
                            <i
                              class="fa fa-times"
                              style="color: white; font-size: 16px"
                            ></i>
                          </b-btn>
                          <label class="ml-2"
                            >Age: {{ personalDetails.Age }}</label
                          >
                          <!-- </b-input-group-append> -->
                          <!-- </b-input-group> -->
                        </span>
                      </td>
                      <td>
                        <span
                          v-if="
                            personalDetails.UserLoanDocuments
                              .BirthCertificate == ''
                          "
                          >Not Uploaded</span
                        >
                        <span
                          v-if="
                            personalDetails.UserLoanDocuments
                              .BirthCertificate != ''
                          "
                        >
                          <a
                            target="_blank"
                            :href="
                              getImgUrl(
                                personalDetails.UserLoanDocuments
                                  .BirthCertificate
                              )
                            "
                            >View</a
                          >
                        </span>
                      </td>
                    </tr>

                    <tr>
                      <td>03.</td>
                      <td>Caste Certificate</td>
                      <td>
                        <span v-if="!editList.eCaste">
                          {{ personalDetails.CasteName }}
                          <b-btn
                            class="float-right"
                            variant="link"
                            @click="EditField('eCaste')"
                          >
                            <i
                              class="fa fa-edit"
                              style="font-size: 14px; color: red"
                            ></i>
                          </b-btn>
                        </span>
                        <span v-if="editList.eCaste">
                          <b-input-group>
                            <!-- <b-form-select v-model ="personalDetails.CasteName" :options="Caste"></b-form-select> -->
                            <b-form-select
                              id="exampleInput5"
                              :options="Caste"
                              value-field="CasteID"
                              text-field="CasteName"
                              required
                              size="sm"
                              v-model="CasteID"
                            ></b-form-select>
                            <b-input-group-append>
                              <b-btn
                                size="sm"
                                @click="EditField('eCaste')"
                                variant="primary"
                              >
                                <i
                                  class="fa fa-save"
                                  style="color: white; font-size: 16px"
                                ></i>
                              </b-btn>
                              <b-btn
                                size="sm"
                                @click="CloseField('eCaste')"
                                variant="info"
                              >
                                <i
                                  class="fa fa-times"
                                  style="color: white; font-size: 16px"
                                ></i>
                              </b-btn>
                            </b-input-group-append>
                          </b-input-group>
                        </span>
                      </td>
                      <td>
                        <span
                          v-if="
                            personalDetails.UserLoanDocuments.CastCertificate ==
                            ''
                          "
                          >Not Uploaded</span
                        >
                        <span
                          v-if="
                            personalDetails.UserLoanDocuments.CastCertificate !=
                            ''
                          "
                        >
                          <a
                            target="_blank"
                            :href="
                              getImgUrl(
                                personalDetails.UserLoanDocuments
                                  .CastCertificate
                              )
                            "
                            >View</a
                          >
                        </span>
                      </td>
                    </tr>

                    <tr>
                      <td>04.</td>
                      <td>Income Certificate</td>
                      <td></td>
                      <td>
                        <span
                          v-if="
                            personalDetails.UserLoanDocuments
                              .IncomeCertificatePath == ''
                          "
                          >Not Uploaded</span
                        >
                        <span
                          v-if="
                            personalDetails.UserLoanDocuments
                              .IncomeCertificatePath != ''
                          "
                        >
                          <a
                            target="_blank"
                            :href="
                              getImgUrl(
                                personalDetails.UserLoanDocuments
                                  .IncomeCertificatePath
                              )
                            "
                            >View</a
                          >
                        </span>
                      </td>
                    </tr>

                    <tr>
                      <td>05.</td>
                      <td>Domicile Certificate</td>
                      <td></td>
                      <td>
                        <span
                          v-if="
                            personalDetails.UserLoanDocuments
                              .DomicileCertificate == ''
                          "
                          >Not Uploaded</span
                        >
                        <span
                          v-if="
                            personalDetails.UserLoanDocuments
                              .DomicileCertificate != ''
                          "
                        >
                          <a
                            target="_blank"
                            :href="
                              getImgUrl(
                                personalDetails.UserLoanDocuments
                                  .DomicileCertificate
                              )
                            "
                            >View</a
                          >
                        </span>
                      </td>
                    </tr>

                    <tr>
                      <td>06.</td>
                      <td>Residance Address</td>
                      <td></td>
                      <td>
                        <span
                          v-if="
                            personalDetails.UserLoanDocuments
                              .ResidentialProofPath == ''
                          "
                          >Not Uploaded</span
                        >
                        <span
                          v-if="
                            personalDetails.UserLoanDocuments
                              .ResidentialProofPath != ''
                          "
                        >
                          <a
                            target="_blank"
                            :href="
                              getImgUrl(
                                personalDetails.UserLoanDocuments
                                  .ResidentialProofPath
                              )
                            "
                            >View</a
                          >
                        </span>
                      </td>
                    </tr>

                    <tr>
                      <td>07.</td>
                      <td>AdharCard</td>
                      <td>
                        <span v-if="!editList.eAadhar">
                          {{ personalDetails.AdharNo }}
                          <b-btn
                            class="float-right"
                            variant="link"
                            @click="EditField('eAadhar')"
                          >
                            <i
                              class="fa fa-edit"
                              style="font-size: 14px; color: red"
                            ></i>
                          </b-btn>
                        </span>
                        <span v-if="editList.eAadhar">
                          <b-input-group>
                            <b-form-input
                              type="text"
                              :state="validateAadhar"
                              size="sm"
                              placeholder="Aadhar Number 12 digit"
                              v-model="personalDetails.AdharNo"
                            ></b-form-input>
                            <b-input-group-append>
                              <b-btn
                                size="sm"
                                @click="EditField('eAadhar')"
                                variant="primary"
                              >
                                <i
                                  class="fa fa-save"
                                  style="color: white; font-size: 16px"
                                ></i>
                              </b-btn>
                              <b-btn
                                size="sm"
                                @click="CloseField('eAadhar')"
                                variant="info"
                              >
                                <i
                                  class="fa fa-times"
                                  style="color: white; font-size: 16px"
                                ></i>
                              </b-btn>
                            </b-input-group-append>
                          </b-input-group>
                        </span>
                      </td>
                      <td>
                        <span
                          v-if="
                            personalDetails.UserLoanDocuments.AddharCardPath ==
                            ''
                          "
                          >Not Uploaded</span
                        >
                        <span
                          v-if="
                            personalDetails.UserLoanDocuments.AddharCardPath !=
                            ''
                          "
                        >
                          <a
                            target="_blank"
                            :href="
                              getImgUrl(
                                personalDetails.UserLoanDocuments.AddharCardPath
                              )
                            "
                            >View</a
                          >
                        </span>
                      </td>
                    </tr>

                    <tr>
                      <td>08.</td>
                      <td>Adhar Card BackSide</td>
                      <td></td>
                      <td>
                        <span
                          v-if="
                            personalDetails.UserLoanDocuments
                              .AddharCardBackPath == ''
                          "
                          >Not Uploaded</span
                        >
                        <span
                          v-if="
                            personalDetails.UserLoanDocuments
                              .AddharCardBackPath != ''
                          "
                        >
                          <a
                            target="_blank"
                            :href="
                              getImgUrl(
                                personalDetails.UserLoanDocuments
                                  .AddharCardBackPath
                              )
                            "
                            >View</a
                          >
                        </span>
                      </td>
                    </tr>

                    <tr>
                      <td>09.</td>
                      <td>RationCard</td>
                      <td>
                        <span v-if="!editList.eRation">
                          {{ personalDetails.RationCardNo }}
                          <b-btn
                            class="float-right"
                            variant="link"
                            @click="EditField('eRation')"
                          >
                            <i
                              class="fa fa-edit"
                              style="font-size: 14px; color: red"
                            ></i>
                          </b-btn>
                        </span>
                        <span v-if="editList.eRation">
                          <b-input-group>
                            <b-form-input
                              size="sm"
                              placeholder="Ration Card Number"
                              type="text"
                              v-model="personalDetails.RationCardNo"
                            ></b-form-input>
                            <b-input-group-append>
                              <b-btn
                                size="sm"
                                @click="EditField('eRation')"
                                variant="primary"
                              >
                                <i
                                  class="fa fa-save"
                                  style="color: white; font-size: 16px"
                                ></i>
                              </b-btn>
                              <b-btn
                                size="sm"
                                @click="CloseField('eRation')"
                                variant="info"
                              >
                                <i
                                  class="fa fa-times"
                                  style="color: white; font-size: 16px"
                                ></i>
                              </b-btn>
                            </b-input-group-append>
                          </b-input-group>
                        </span>
                      </td>
                      <td>
                        <span
                          v-if="
                            personalDetails.UserLoanDocuments.RationCardPath ==
                            ''
                          "
                          >Not Uploaded</span
                        >
                        <span
                          v-if="
                            personalDetails.UserLoanDocuments.RationCardPath !=
                            ''
                          "
                        >
                          <a
                            target="_blank"
                            :href="
                              getImgUrl(
                                personalDetails.UserLoanDocuments.RationCardPath
                              )
                            "
                            >View</a
                          >
                        </span>
                      </td>
                    </tr>

                    <tr>
                      <td>10.</td>
                      <td>Ration Card Last Page</td>
                      <td>{{ personalDetails.RationCardNo }}</td>
                      <td>
                        <span
                          v-if="
                            personalDetails.UserLoanDocuments
                              .RationCardLastPath == ''
                          "
                          >Not Uploaded</span
                        >
                        <span
                          v-if="
                            personalDetails.UserLoanDocuments
                              .RationCardLastPath != ''
                          "
                        >
                          <a
                            target="_blank"
                            :href="
                              getImgUrl(
                                personalDetails.UserLoanDocuments
                                  .RationCardLastPath
                              )
                            "
                            >View</a
                          >
                        </span>
                      </td>
                    </tr>

                    <tr>
                      <td>11.</td>
                      <td>PAN Card</td>
                      <td>
                        <span v-if="!editList.ePan">
                          {{ personalDetails.PanCardNo }}
                          <b-btn
                            class="float-right"
                            variant="link"
                            @click="EditField('ePan')"
                          >
                            <i
                              class="fa fa-edit"
                              style="font-size: 14px; color: red"
                            ></i>
                          </b-btn>
                        </span>
                        <span v-if="editList.ePan">
                          <b-input-group>
                            <b-form-input
                              type="text"
                              v-model="personalDetails.PanCardNo"
                              :state="validatePan"
                              size="sm"
                              placeholder="PAN 10 digit"
                            ></b-form-input>
                            <b-input-group-append>
                              <b-btn
                                size="sm"
                                @click="EditField('ePan')"
                                variant="primary"
                              >
                                <i
                                  class="fa fa-save"
                                  style="color: white; font-size: 16px"
                                ></i>
                              </b-btn>
                              <b-btn
                                size="sm"
                                @click="CloseField('ePan')"
                                variant="info"
                              >
                                <i
                                  class="fa fa-times"
                                  style="color: white; font-size: 16px"
                                ></i>
                              </b-btn>
                            </b-input-group-append>
                          </b-input-group>
                        </span>
                      </td>
                      <td>
                        <span
                          v-if="
                            personalDetails.UserLoanDocuments.PancardPath == ''
                          "
                          >Not Uploaded</span
                        >
                        <span
                          v-if="
                            personalDetails.UserLoanDocuments.PancardPath != ''
                          "
                        >
                          <a
                            target="_blank"
                            :href="
                              getImgUrl(
                                personalDetails.UserLoanDocuments.PancardPath
                              )
                            "
                            >View</a
                          >
                        </span>
                      </td>
                    </tr>
                    <tr>
                      <td>12.</td>
                      <td>Bank Account Proof</td>
                      <td>
                        <span v-if="!editList.eAccount">
                          {{ personalDetails.UserBankAccount.BankAccountNo }}
                          <b-btn
                            class="float-right"
                            variant="link"
                            @click="EditField('eAccount')"
                          >
                            <i
                              class="fa fa-edit"
                              style="font-size: 14px; color: red"
                            ></i>
                          </b-btn>
                        </span>
                        <span v-if="editList.eAccount">
                          <b-input-group>
                            <b-form-input
                              type="text"
                              v-model="
                                personalDetails.UserBankAccount.BankAccountNo
                              "
                            ></b-form-input>
                            <b-input-group-append>
                              <b-btn
                                size="sm"
                                @click="EditField('eAccount')"
                                variant="primary"
                              >
                                <i
                                  class="fa fa-save"
                                  style="color: white; font-size: 16px"
                                ></i>
                              </b-btn>
                              <b-btn
                                size="sm"
                                @click="CloseField('eAccount')"
                                variant="info"
                              >
                                <i
                                  class="fa fa-times"
                                  style="color: white; font-size: 16px"
                                ></i>
                              </b-btn>
                            </b-input-group-append>
                          </b-input-group>
                        </span>
                      </td>
                      <td>
                        <span
                          v-if="
                            personalDetails.UserLoanDocuments.BankAccount == ''
                          "
                          >Not Uploaded</span
                        >
                        <span
                          v-if="
                            personalDetails.UserLoanDocuments.BankAccount != ''
                          "
                        >
                          <a
                            target="_blank"
                            :href="
                              getImgUrl(
                                personalDetails.UserLoanDocuments.BankAccount
                              )
                            "
                            >View</a
                          >
                        </span>
                      </td>
                    </tr>
                    <tr>
                      <td>13.</td>
                      <td>Other Documents</td>
                      <td></td>
                      <td>
                        <span
                          v-if="
                            personalDetails.UserLoanDocuments.OtherDocument ==
                            ''
                          "
                          >Not Uploaded</span
                        >
                        <span
                          v-if="
                            personalDetails.UserLoanDocuments.OtherDocument !=
                            ''
                          "
                        >
                          <a
                            target="_blank"
                            :href="
                              getImgUrl(
                                personalDetails.UserLoanDocuments.OtherDocument
                              )
                            "
                            >View</a
                          >
                        </span>
                      </td>
                    </tr>
                    <tr v-if="personalDetails.UserLoanDocuments.Other4 != ''">
                      <td>14.</td>
                      <td>DBSC Approval Letter</td>
                      <td></td>
                      <td>
                        <span
                          v-if="personalDetails.UserLoanDocuments.Other4 == ''"
                          >Not Uploaded</span
                        >
                        <span
                          v-if="personalDetails.UserLoanDocuments.Other4 != ''"
                        >
                          <a
                            target="_blank"
                            :href="
                              getImgUrl(
                                personalDetails.UserLoanDocuments.Other4
                              )
                            "
                            >View</a
                          >
                        </span>
                      </td>
                    </tr>
                    <tr v-if="personalDetails.UserLoanDocuments.Other2 != ''">
                      <td>14.</td>
                      <td>
                        {{ personalDetails.UserLoanDocuments.Other2Name }}
                      </td>
                      <td></td>
                      <td>
                        <span
                          v-if="personalDetails.UserLoanDocuments.Other2 == ''"
                          >Not Uploaded</span
                        >
                        <span
                          v-if="personalDetails.UserLoanDocuments.Other2 != ''"
                        >
                          <a
                            target="_blank"
                            :href="
                              getImgUrl(
                                personalDetails.UserLoanDocuments.Other2
                              )
                            "
                            >View</a
                          >
                        </span>
                      </td>
                    </tr>
                    <tr v-if="personalDetails.UserLoanDocuments.Other3 != ''">
                      <td>15.</td>
                      <td>
                        {{ personalDetails.UserLoanDocuments.Other3Name }}
                      </td>
                      <td></td>
                      <td>
                        <span
                          v-if="personalDetails.UserLoanDocuments.Other3 == ''"
                          >Not Uploaded</span
                        >
                        <span
                          v-if="personalDetails.UserLoanDocuments.Other3 != ''"
                        >
                          <a
                            target="_blank"
                            :href="
                              getImgUrl(
                                personalDetails.UserLoanDocuments.Other3
                              )
                            "
                            >View</a
                          >
                        </span>
                      </td>
                    </tr>
                    <tr v-if="personalDetails.UserLoanDocuments.Other4 != ''">
                      <td>16.</td>
                      <td>
                        {{ personalDetails.UserLoanDocuments.Other4Name }}
                      </td>
                      <td></td>
                      <td>
                        <span
                          v-if="personalDetails.UserLoanDocuments.Other4 == ''"
                          >Not Uploaded</span
                        >
                        <span
                          v-if="personalDetails.UserLoanDocuments.Other4 != ''"
                        >
                          <a
                            target="_blank"
                            :href="
                              getImgUrl(
                                personalDetails.UserLoanDocuments.Other4
                              )
                            "
                            >View</a
                          >
                        </span>
                      </td>
                    </tr>
                  </table>
                </b-container>
              </b-col>
            </b-row>
          </b-container>
        </div>
      </div>
      <div class="reg-form-box">
        <Spinner size="32" message="Loading..." v-if="isLoading"></Spinner>

        <b-container class="bv-example-row">
          <b-row>
            <b-col cols="10" offset="1">
              <h5 class="reg-form-title text-primary">Approval History</h5>
              <b-table
                show-empty
                selectable
                select-mode="multi"
                head-variant="dark"
                empty-text="No Applications available."
                stacked="md"
                bordered
                striped
                :items="approvalRemarks"
                :fields="approvalFields"
                variant="dark"
                style="font-size: 12px"
              ></b-table>
            </b-col>
          </b-row>
          <b-row
            class="mt-3"
            v-if="personalDetails.LoanApplication[0].ApprovalDoc != ''"
          >
            <b-col cols="8" offset="1">
              <p>
                <b>DBSC Approval Status</b>
                : {{ personalDetails.LoanApplication[0].ApprovalStatus }}
                <a
                  class="ml-2"
                  target="_blank"
                  :href="
                    getImgUrl2(personalDetails.LoanApplication[0].ApprovalDoc)
                  "
                  >View Approval Report</a
                >
              </p>
              <p>
                <b>Meeting Date</b>
                :
                {{
                  personalDetails.LoanApplication[0].MeetingDate | formatDate
                }}
              </p>
            </b-col>
          </b-row>
        </b-container>
        <b-container class="bv-example-row" v-if="showHistory">
          <b-row>
            <b-col cols="10" offset="1">
              <h5 class="reg-form-title text-primary">
                Approval History of Rejected Applications
                <b-btn variant="link" aria-controls="collapse-4"
                  @click="visible = !visible">Show</b-btn>
              </h5>
              <b-collapse
                id="collapse-4" v-model="visible"
              >
                <b-table
                  show-empty
                  selectable
                  select-mode="multi"
                  head-variant="dark"
                  empty-text="No Applications available."
                  stacked="md"
                  bordered
                  striped
                  :items="approvalRemarksLink"
                  :fields="approvalLinkFields"
                  variant="dark"
                  style="font-size: 12px"
                ></b-table>
              </b-collapse>
            </b-col>
          </b-row>
        </b-container>
      </div>
    </div>
    <!-- Printme id ends here -->

    <div class="reg-form-box">
      <Spinner size="32" message="Loading..." v-if="isLoading"></Spinner>
      <b-alert
        :show="showDismissibleAlert"
        dismissible
        @dismissed="showDismissibleAlert = false"
        :variant="variant"
        >{{ alertText }}</b-alert
      >

      <!-- <b-form @submit="onSubmit" class="hide-print" v-if="(
        ApplicationStatus==15 && RoleID==2) || (ApplicationStatus==1 && RoleID==2) || (ApplicationStatus==5 && RoleID==2) ||
        (ApplicationStatus==3 && RoleID==2) || (ApplicationStatus==13 && RoleID==3) || (ApplicationStatus==17 && RoleID==3) ||
        (ApplicationStatus==19 && RoleID==3) ||
      (ApplicationStatus==4 && RoleID==5) || (ApplicationStatus==16 && RoleID==4) || (ApplicationStatus==7 && RoleID==5)"> -->
      <b-form @submit="onSubmit" class="hide-print" v-if="showApproval">
        <div class="form-row">
          <div class="form-group col-md-1"></div>
          <div class="form-group col-md-4">
            <!--<label for="ipDistrict" size="sm">District</label> -->
            <b-form-group
              id="fieldset-horizontal"
              label-cols-sm="4"
              label-cols-lg="4"
              label="Approve Application"
              label-for="ipDistrict"
              label-size="sm"
            >
              <b-select
                id="ipDistrict"
                :options="ApprovalStatus"
                value-field="StatusID"
                text-field="Status"
                required
                size="sm"
                @change.native="checkReject"
                v-model="form.ApplicationStatus"
                class="form-control"
              ></b-select>
            </b-form-group>
          </div>
          <div class="form-group col-md-1"></div>
          <div class="form-group col-md-4">
            <b-form-group
              id="fieldset-horizontal2"
              label-cols-sm="4"
              label-cols-lg="4"
              label="Reject Reason"
              label-for="ipReason"
              label-size="sm"
            >
              <!-- <b-select id="ipReason"
                :options="RejectReasons"
                value-field="RejectedID"
                text-field="RejectedTypeName"
                required
                size="sm"
                :disabled="form.ApplicationStatus!=3 && form.ApplicationStatus !=5 && form.ApplicationStatus !=7 && form.ApplicationStatus !=17 && form.ApplicationStatus !=18"
                v-model="form.RejectReason"
              class="form-control">-->
              <b-select
                id="ipReason"
                :options="RejectReasons"
                value-field="RejectedID"
                text-field="RejectedTypeName"
                required
                size="sm"
                :disabled="!isReject"
                v-model="form.RejectReason"
                class="form-control"
              ></b-select>
            </b-form-group>
          </div>
        </div>
        <div class="form-row">
          <div class="form-group col-md-1"></div>
          <div class="form-group col-md-9" style="text-align: left">
            <!--<label for="ipDistrict" size="sm">District</label> -->
            <b-form-group
              id="fieldset-horizontal"
              label-cols-sm="4"
              label-cols-md="1"
              label="Remarks"
              label-for="ipRemarks"
              label-size="sm"
            >
              <!-- <b-form-textarea id="ipRemarks"
                v-model="form.Remarks"
                :required="form.ApplicationStatus==3 && form.ApplicationStatus ==5 && form.ApplicationStatus ==7 && form.ApplicationStatus ==17"
                size="sm"
                rows=2, max-rows="4"
              placeholder="Remarks">-->
              <b-form-textarea
                id="ipRemarks"
                v-model="form.Remarks"
                :required="isReject"
                size="sm"
                rows="2,"
                max-rows="4"
                placeholder="Remarks"
              ></b-form-textarea>
            </b-form-group>
          </div>
        </div>
        <b-col style="text-align: center" class="mb-3">
          <b-button
            class="hide-print"
            type="submit"
            variant="primary"
            v-if="showButton"
            >Submit</b-button
          >
        </b-col>
      </b-form>
      <div class="text-center">
        <b-button
          class="hide-print"
          @click.prevent="goback"
          variant="secondary"
          size="small"
          >BACK</b-button
        >
      </div>
    </div>
    <b-modal ref="loiModal" size="xl" hide-footer title="LOI" lazy>
      <LoanLOIPrint
        :ApplicationID="form.ApplicationID"
        :Loantype="this.LoanType"
        :UserID="UserID"
        :PastLOI="PastLOI"
      ></LoanLOIPrint>
    </b-modal>

    <!-- Edit Personal Details Modal (Role 0 only) -->
    <b-modal
      ref="editPersonalModal"
      size="lg"
      title="Edit Personal Details"
      @ok="savePersonalDetailsAdmin"
      ok-title="Save"
      cancel-title="Cancel"
    >
      <b-alert :show="modalAlert.show" :variant="modalAlert.variant" dismissible @dismissed="modalAlert.show=false">{{ modalAlert.text }}</b-alert>
      <b-form>
        <b-row>
          <b-col md="4">
            <b-form-group label="First Name*" label-size="sm">
              <b-form-input v-model="editPersonalForm.FirstName" size="sm" required></b-form-input>
            </b-form-group>
          </b-col>
          <b-col md="4">
            <b-form-group label="Middle Name" label-size="sm">
              <b-form-input v-model="editPersonalForm.MiddleName" size="sm"></b-form-input>
            </b-form-group>
          </b-col>
          <b-col md="4">
            <b-form-group label="Last Name*" label-size="sm">
              <b-form-input v-model="editPersonalForm.LastName" size="sm" required></b-form-input>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col md="4">
            <b-form-group label="Date Of Birth*" label-size="sm">
              <date-picker v-model="editPersonalDOB" format="DD-MM-YYYY" lang="en" size="small"></date-picker>
            </b-form-group>
          </b-col>
          <b-col md="4">
            <b-form-group label="Gender" label-size="sm">
              <b-form-radio-group v-model="editPersonalForm.Gender">
                <b-form-radio :value="true">Male</b-form-radio>
                <b-form-radio :value="false">Female</b-form-radio>
              </b-form-radio-group>
            </b-form-group>
          </b-col>
          <b-col md="4">
            <b-form-group label="Married Status" label-size="sm">
              <b-form-radio-group v-model="editPersonalForm.MaritalStatus">
                <b-form-radio :value="true">Married</b-form-radio>
                <b-form-radio :value="false">Unmarried</b-form-radio>
              </b-form-radio-group>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col md="4">
            <b-form-group label="Mobile No*" label-size="sm">
              <b-form-input v-model="editPersonalForm.MobileNo" size="sm" type="number"></b-form-input>
            </b-form-group>
          </b-col>
          <b-col md="4">
            <b-form-group label="Email ID" label-size="sm">
              <b-form-input v-model="editPersonalForm.EmailID" size="sm" type="email"></b-form-input>
            </b-form-group>
          </b-col>
          <b-col md="4">
            <b-form-group label="Aadhar No" label-size="sm">
              <b-form-input v-model="editPersonalForm.AdharNo" size="sm" placeholder="12 digit"></b-form-input>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col md="4">
            <b-form-group label="PAN No" label-size="sm">
              <b-form-input v-model="editPersonalForm.PanCardNo" size="sm"></b-form-input>
            </b-form-group>
          </b-col>
          <b-col md="4">
            <b-form-group label="Ration Card No" label-size="sm">
              <b-form-input v-model="editPersonalForm.RationCardNo" size="sm"></b-form-input>
            </b-form-group>
          </b-col>
          <b-col md="4">
            <b-form-group label="Family Income (Rs)" label-size="sm">
              <b-form-input v-model="editPersonalForm.FamilyIncome" size="sm" type="number"></b-form-input>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col md="4">
            <b-form-group label="Caste" label-size="sm">
              <b-form-select v-model="editPersonalForm.CasteID" :options="Caste" value-field="CasteID" text-field="CasteName" size="sm"></b-form-select>
            </b-form-group>
          </b-col>
          <b-col md="4">
            <b-form-group label="Indian National" label-size="sm">
              <b-form-radio-group v-model="editPersonalForm.Nationality">
                <b-form-radio :value="true">Yes</b-form-radio>
                <b-form-radio :value="false">No</b-form-radio>
              </b-form-radio-group>
            </b-form-group>
          </b-col>
          <b-col md="4">
            <b-form-group label="Maharashtra Domicile" label-size="sm">
              <b-form-radio-group v-model="editPersonalForm.Domiciled">
                <b-form-radio :value="true">Yes</b-form-radio>
                <b-form-radio :value="false">No</b-form-radio>
              </b-form-radio-group>
            </b-form-group>
          </b-col>
        </b-row>
      </b-form>
    </b-modal>

    <!-- Edit Lending Loan Details Modal (Role 0 only) -->
    <b-modal
      ref="editLendingLoanModal"
      size="lg"
      title="Edit Lending Loan Details"
      @ok="saveLendingLoanAdmin"
      ok-title="Save"
      cancel-title="Cancel"
    >
      <b-alert :show="modalAlert.show" :variant="modalAlert.variant" dismissible @dismissed="modalAlert.show=false">{{ modalAlert.text }}</b-alert>
      <b-form>
        <b-row>
          <b-col md="6">
            <b-form-group label="Organization / Institute Name" label-size="sm">
              <b-form-input v-model="editLendingLoanForm.UserLendingLoanDetails.OrganizationName" size="sm"></b-form-input>
            </b-form-group>
          </b-col>
          <b-col md="6">
            <b-form-group label="Organization / Institute Address" label-size="sm">
              <b-form-input v-model="editLendingLoanForm.UserLendingLoanDetails.OrganizationAddress" size="sm"></b-form-input>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col md="6">
            <b-form-group label="Product / Course Name" label-size="sm">
              <b-form-input v-model="editLendingLoanForm.UserLendingLoanDetails.ProductfromOrganization" size="sm"></b-form-input>
            </b-form-group>
          </b-col>
          <b-col md="6">
            <b-form-group label="Amount From Bank (Rs)" label-size="sm">
              <b-form-input v-model="editLendingLoanForm.UserLendingLoanDetails.AmountFromBank" size="sm" type="number"></b-form-input>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col md="6">
            <b-form-group label="Bank Name" label-size="sm">
              <b-form-input v-model="editLendingLoanForm.UserLendingLoanDetails.BankName" size="sm"></b-form-input>
            </b-form-group>
          </b-col>
          <b-col md="6">
            <b-form-group label="Branch" label-size="sm">
              <b-form-input v-model="editLendingLoanForm.UserLendingLoanDetails.Branch" size="sm"></b-form-input>
            </b-form-group>
          </b-col>
        </b-row>
      </b-form>
    </b-modal>
  </b-container>
</template>

<script>
import apis from "@/apis";
import vueHtmlToPaper from "vue-html-to-paper";
import DatePicker from "vue2-datepicker";
import Formatter from "@/Formatter.js";
import Spinner from "vue-simple-spinner";
import LoanLOIPrint from "@/components/RegistrationLoan/LoanLOIPrint";

export default {
  components: { Spinner, DatePicker, LoanLOIPrint },
  props: ["UserID", "ApplicationStatus"],
  data() {
    return {
      visible: true,
      showButton: true,
      showApproval: false,
      isReject: false,
      required: false,
      Caste: [],
      CasteID: "",
      PastLOI: false,
      personalDetails: {
        UserID: null,
        Salutation: null,
        FullName: null,
        FirstName: "",
        MiddleName: "",
        LastName: "",
        DOB: null,
        Age: 38,
        PlaceOfBirth: "",
        Gender: true,
        MotherName: "",
        MobileNo: "",
        MobileNo1: null,
        LandlineNo: null,
        MaritalStatus: true,
        MotherToungue: true,
        EmailID: "",
        Nationality: true,
        Domiciled: true,
        MotherToung: "Hindi",
        AdharNo: "",
        PanCardNo: "",
        CategoryType: null,
        BoardID: "a1bfdfd8-db30-4d39-87f7-5f2eddd7f810",
        RegistrationType: 2,

        LoginID: "00000000-0000-0000-0000-000000000000",
        ApplicationID: "00000000-0000-0000-0000-000000000000",

        LockProfile: true,
        RegistrationTypeName: "",
        BoardName: "",
        PermanentAddress: {
          StateID: "bb62f7b0-748d-4e64-ad4f-8ef691431fa1",
          DistrictID: "8de132b0-61d8-45f6-a953-ea3e9dff25e2",
          TalukaID: "f6cd7bd0-3d6e-4551-83ff-f57db3fd0ee5",
          HouseNo: "",
          BuildingNo: "",
          Street: "",
          Locality: "",
          Landmark: "",
          Village: "",
          Pincode: 400612,
          Post: "",
          StateName: "",
          DistrictName: "",
          TalukaName: "",
        },

        CorrespondenceAddress: {
          StateID: "bb62f7b0-748d-4e64-ad4f-8ef691431fa1",
          DistrictID: "8de132b0-61d8-45f6-a953-ea3e9dff25e2",
          TalukaID: "f6cd7bd0-3d6e-4551-83ff-f57db3fd0ee5",
          HouseNo: "",
          BuildingNo: "",
          Street: "",
          Locality: "",
          Landmark: "",
          Village: "",
          Pincode: 0,
          Post: "",
          ResidanceSince: 1,
          StateName: "Maharashtra",
          DistrictName: "Thane",
          TalukaName: "Thane",
        },
        UserBankAccount: {
          BankAccept: true,
          BankID: "f6cd7bd0-3d6e-4551-83ff-f57db3fd0ee5",
          BankName: "",
          BranchName: "",
          City: "",
          Comment: "",
          BankAccountNo: "",
          BankIfscCode: "",
        },
        UserLendingLoanDetails: {
          AmountFromBank: "",
          LoanDistrict: "",
          OrganizationAddress: "",
          OrganizationName: "",
          ProductfromOrganization: "",
          UserLendingLoanID: "",
        },
        UserPhysicalDetails: {
          UserPhysicalID: null,
          IndetificationMark: "",
          Height: 188,
          Weight: 85,
          ChestDeflated: 100,
          ChestInflated: 105,
        },
        UserQualification: {
          QualificationTypeID: "09713307-253d-4e35-aca9-50ccde3e05a6",
          DegreeID: "03c001dc-b65e-4b96-bd25-f4e425c7fab6",
          StateID: "6e394345-c136-4618-9258-d3bd530fd97b",
          BoardID: "80d06c9d-8256-4b83-ad87-620debf38d32",
          Result: 1,
          Percentage: 66.0,
          Class: "First Class",
          QualificationType: {
            QualificationTypeID: null,
            QualificationTypeName: "Graduate",
          },
          DegreeType: {
            DegreeTypeID: null,
            DegreeName: "B.A.",
            QaulificaitonTypeID: "00000000-0000-0000-0000-000000000000",
          },
          UserState: {
            StateID: "00000000-0000-0000-0000-000000000000",
            StateName: "Bihar",
          },
          EducationBoard: {
            BoardID: null,
            BoardName: "",
            InstituteType: null,
            StateID: "00000000-0000-0000-0000-000000000000",
          },
        },
        UserLoanDocuments: {
          AddharCardPath: null,
          AddharCardPath: null,
          BirthCertificate: null,
          CastCertificate: null,
          CasteCertificate: null,
          CourtOrder: null,
          DeceasedID: null,
          EduCertificate: null,
          ExServiceManProof: null,
          ExprienceCertificate: null,
          FinalDuesLetter: null,
          IncomeTaxApplication: null,
          LegalHireNOC: null,
          MedicalCertificate: null,
          OtherDocument: null,
          PFDeclaration: null,
          PancardPath: null,
          PersonResolutionPath: null,
          PhotoPath: null,
          PoliceVerification: null,
          RationCardPath: null,
          RecommendationLetter: null,
          RegCopy: null,
          ResidentialProofPath: null,
          SignaturePath: null,
          IncomeCertificatePath: null,
        },
        UserDocuments: {
          PhotoPath: null,
          SignaturePath: null,
          AddharCardPath: null,
          PancardPath: null,
          RationCardPath: null,
          CasteCertificate: null,
          EduCertificate: null,
          ExServiceManProof: null,
          ExprienceCertificate: null,
          BirthCertificate: null,
          PoliceVerification: null,
          MedicalCertificate: null,
          RecommendationLetter: null,
          DeceasedID: null,
          LegalHireNOC: null,
          FinalDuesLetter: null,
          CourtOrder: null,
        },
        UserEmergencyContact: {
          ContactName: "",
          Address: "",
          MobileNo: "",
        },
        UserOtherDetails: {
          WorkingYears: "",
          EmployerName: "",
          LoadCapcity: "",
          UnionName: "",
          AccidentHistory: "",
          MedicallyFit: "",
          CriminalCase: "",
          ToliName: "",
          ToliNumber: "",
        },
        UserReligionCaste: {
          ReligionID: "d3f6b84b-c005-474d-aff9-dd27fa763ebc",
          CategoryID: "d25679fb-92ea-434d-a0f8-65b3290c7a8b",
          ReligionName: null,
          CategoryType: null,
          SubCaste: "",
        },
        UserEmploymentExchange: {
          EmploymentName: null,
          EmploymentRegNo: null,
          EmploymentExchangeStatus: false,
        },
        UserDecleration: {
          UserID: "00000000-0000-0000-0000-000000000000",
          ConfirmStatus: false,
          DeclerationText: null,
        },
        ApplyForJob: {
          ApplicationID: "00000000-0000-0000-0000-000000000000",
          JobId: "00000000-0000-0000-0000-000000000000",
          UserID: "00000000-0000-0000-0000-000000000000",
          Status: 0,
          PersonalDetail: false,
          AddressDetail: false,
          OtherDetail: false,
          ExprienceDetail: false,
          QualificationDetail: false,
          DocumentUpload: false,
          DeclerationDetail: false,
          PaymentStatus: false,
          ApplicationNo: null,
        },
        UserApplication: [],
        UserEvaluation: {
          ApplicationID: "00000000-0000-0000-0000-000000000000",
          BatchID: "00000000-0000-0000-0000-000000000000",
          RunningMark: 0,
          PullUps: 0,
          Situps: 0,
          EducationalMarks: 0,
          Height: 0,
          Weight: 0,
          ChestDeflated: 0,
          ChestInflated: 0,
        },
        UserDocumentReview: {
          Review: false,
          Comments: null,
          ApplicationID: "00000000-0000-0000-0000-000000000000",
        },
        UserDocumentUpload: {
          ApplicantPhotoStatus: false,
          ApplicantSignatureStatus: false,
          AdharCardStatus: false,
          RationCardStatus: false,
          DOBCertificateStatus: false,
          CasteCertificateStatus: false,
          DegreeCertificateStatus: false,
          ExprienceCertificateStatus: false,
          ExServiceManCertificateStatus: false,
        },
        UserDocuments: {
          PhotoPath: "",
          SignaturePath: "",
          AddharCardPath: "",
          PancardPath: "",
          RationCardPath: "",
          CasteCertificate: "",
          EduCertificate: "",
          ExServiceManProof: "",
          ExprienceCertificate: "",
          BirthCertificate: "",
          RecommendationLetter: "",
          CourtOrder: "",
          DeceasedID: "",
          LegalHireNOC: "",
          FinalDuesLetter: "",
        },
        UserNominee: [
          {
            NomineeID: "2ff23306-0f82-4613-8197-1aff4533d8b1",
            NomineeName: "",
            Gender: false,
            DOB: "",
            ReletionShip: 3,
            ReletionshipName: "",
            UserID: "00000000-0000-0000-0000-000000000000",
          },
        ],
        UserProfileStatus: {
          PersonalDetail: false,
          AddressDetail: false,
          PhysicalDetail: false,
          NomineeDetail: false,
          ExprienceDetail: false,
          QualificationDetail: false,
          DocumentUpload: false,
          DeclerationDetail: false,
          PaymentStatus: false,
          FamilyDetail: false,
        },
        LoanApplication: [
          {
            LoanType: "",
            UserID: "",
            LoanApplicationID: "",
            LoanApplicationNo: "",
            SchemeType: "",
            GroupID: "",
            AmountDemanded: "",
            ApplicationStatus: "",
            AmountApproved: "",
            Level1Approver: "",
            Level1ApprovalDate: "",
            Level2Approver: "",
            Level2ApprovalDate: "",
            LOIDate: "",
            BankID: "",
            BankApprovalDate: "",
            BankLoanAmount: "",
            BankInterestRate: "",
            LoanTenure: "",
            LoanStartDate: "",
            LoanEndDate: "",
            LoanStatus: "",
          },
        ],
        UserFamily: [
          {
            FamilyID: "efc2815c-68ef-4211-b804-2dde92d97522",
            FullName: "",
            Gender: false,
            DOB: "",
            ReletionShipID: "6fce0f55-2fb6-45b3-ad1f-aa6eb9cecae7",
            ReletionshipName: "",
            UserID: "00000000-0000-0000-0000-000000000000",
          },
          {
            FamilyID: "026e72ee-55b9-4fd4-8a58-3e0f96a08ed4",
            FullName: "",
            Gender: true,
            DOB: "2014-06-03T00:00:00",
            ReletionShipID: "435ea13a-01f6-4360-aa7c-eabb5e4a791a",
            ReletionshipName: "",
            UserID: "00000000-0000-0000-0000-000000000000",
          },
          {
            FamilyID: "413f61a2-1b95-49b9-b397-8cc53994f134",
            FullName: "",
            Gender: false,
            DOB: "1983-12-24T00:00:00",
            ReletionShipID: "f57b429f-481e-47f3-a6dd-99acc6456b56",
            ReletionshipName: "",
            UserID: "00000000-0000-0000-0000-000000000000",
          },
        ],
      },
      docObj: {},
      docTbl: [],
      form: {
        ApplicationStatus: 1,
        RejectReason: 0,
        Remarks: "",
        UserID: "",
        ApplicationID: "",
      },
      RoleID: 0,
      ApprovalStatus: [
        //{ StatusID: 1, Status: "Pending" },
        { StatusID: 2, Status: "Verified" },
        { StatusID: 3, Status: "Hold" },
        { StatusID: 19, Status: "Rejected" },
        //{ StatusID: 15, Status: "Scheduled" }
      ],
      approvalRemarks: [],
      approvalRemarksLink: [],
      approvalFields: [
        "ApplicationStatus",
        "RejectionReason",
        "Remarks",
        {
          key: "LogDate",
          label: "Approve/Reject Date",
          formatter: "convertDateFormat",
        },
        "ApproverName",
      ],
      approvalLinkFields: [
        "ApplicationNo",
        "ApplicationStatus",
        "RejectionReason",
        "Remarks",
        {
          key: "LogDate",
          label: "Approve/Reject Date",
          formatter: "convertDateFormat",
        },
        "ApproverName",
      ],
      RejectReasons: [],
      alertText: "",
      variant: "success",
      isLoading: false,
      showDismissibleAlert: false,
      editList: {
        eDOB: false,
        ePan: false,
        eAadhar: false,
        eRation: false,
        eCaste: false,
        eAccount: false,
        eAddress: false,
      },
      DOB: null,
      updateForm: {
        UserID: null,
        LoanApplicationID: null,
        DOB: null,
        Age: null,
        Pan: null,
        Aadhar: null,
        BankAccount: null,
        RationCard: null,
        CasteID: null,
        CreatedUser: null,
      },
      showHistory: false,
      modalAlert: {
        show: false,
        text: "",
        variant: "success",
      },
      editPersonalForm: {
        LoginID: "",
        FirstName: "",
        MiddleName: "",
        LastName: "",
        Gender: true,
        DOB: null,
        Age: 0,
        MobileNo: "",
        EmailID: "",
        AdharNo: "",
        PanCardNo: "",
        MaritalStatus: false,
        Nationality: true,
        Domiciled: true,
        CasteID: "",
        FamilyIncome: 0,
        RationCardNo: "",
        RegistrationType: 1,
      },
      editPersonalDOB: null,
      editLendingLoanForm: {
        LoginID: "",
        UserLendingLoanDetails: {
          OrganizationName: "",
          ProductfromOrganization: "",
          OrganizationAddress: "",
          AmountFromBank: "",
          LoanDistrict: "",
          BankName: "",
          Branch: "",
        },
      },
    };
  },
  computed: {
    validateAadhar() {
      if (this.personalDetails.AdharNo == null) {
        return false;
      }

      if (this.personalDetails.AdharNo.length == 0) {
        return false;
      } else if (this.personalDetails.AdharNo != null) {
        var adharformat = /^\d{12}$/;
        if (this.personalDetails.AdharNo.match(adharformat)) {
          return true;
        } else {
          return false;
        }
      } else {
        return false;
      }
    },
    validatePan() {
      if (this.personalDetails.PanCardNo == null) {
        return false;
      }

      if (this.personalDetails.PanCardNo.length == 0) {
        return false;
      } else if (this.personalDetails.PanCardNo != null) {
        var panformat = /^([a-zA-Z]){5}([0-9]){4}([a-zA-Z]){1}?$/;
        if (this.personalDetails.PanCardNo.match(panformat)) {
          return true;
        } else {
          return false;
        }
      } else {
        return false;
      }
    },
    validateAge() {
      // console.log('1');
      //let age = this.calculateAge(this.form.DOB);

      let age = this.calculateAge(this.DOB);
      this.PersonalDetails.Age = age;
      if (age < 18 || age >= 50) {
        return false;
      } else {
        return true;
      }
    },
  },
  methods: {
    getApiErrorText(error, fallbackText) {
      const fallback = fallbackText || "Unable to save changes.";
      if (!error) return fallback;

      if (typeof error === "string" && error.trim()) return error;
      if (error.message && typeof error.message === "string" && error.message.trim()) return error.message;

      const body = error.body;
      if (typeof body === "string" && body.trim()) return body;
      if (body && typeof body === "object") {
        const bodyMessage = body.message || body.Message || body.error_description || body.error || body.title;
        if (typeof bodyMessage === "string" && bodyMessage.trim()) return bodyMessage;
      }

      if (typeof error.bodyText === "string" && error.bodyText.trim()) return error.bodyText;
      if (typeof error.statusText === "string" && error.statusText.trim() && error.statusText.toLowerCase() !== "error") return error.statusText;
      if (error.status) return "Request failed with status " + error.status;

      return fallback;
    },

    setManualApprovalOptions() {
      let newOptions = [];

      // LOI Extension approval workflow for Role 2
      if (this.RoleID == 2 && this.ApplicationStatus == 23) {
        newOptions = [
          { StatusID: 24, Status: "LOI Extended" },
          { StatusID: 25, Status: "LOI Extension Rejected" }
        ];
        this.showApproval = true;
      }
      // Other role-based approval workflows - only while the app is actually pending at that role's stage
      else if (this.RoleID == 3 && this.ApplicationStatus == 2) {
        newOptions = [
          { StatusID: 4, Status: "Approved by DBSC" },
          { StatusID: 5, Status: "Rejected by DBSC" },
          // RM should be able to send the application back to the DM.
          { StatusID: 1, Status: "Return to DM" }
        ];
        this.showApproval = true;
      }
      else if (this.RoleID == 2 && this.ApplicationStatus == 5) {
        newOptions = [
          { StatusID: 19, Status: "Verified" },
          { StatusID: 3, Status: "Hold" },
          { StatusID: 18, Status: "Rejected" }
        ];
        this.showApproval = true;
      }
      // DM receives application returned by GM/PM/MD - can reject to beneficiary or re-verify
      else if (this.RoleID == 2 && [17, 20, 28, 31, 33].includes(this.ApplicationStatus)) {
        newOptions = [
          { StatusID: 18, Status: "Reject to Beneficiary" },
          { StatusID: 19, Status: "Re-verify and Forward" }
        ];
        this.showApproval = true;
      }
      // MD only acts once GM has recommended (status 16 = pending MD)
      else if (this.RoleID == 4 && this.ApplicationStatus == 16) {
        newOptions = [
          { StatusID: 6, Status: "Approved" },
          { StatusID: 7, Status: "Rejected" }
        ];
        this.showApproval = true;
      }
      // GM only acts once PM has recommended (status 30 = pending GM)
      else if (this.RoleID == 5 && this.ApplicationStatus == 30) {
        newOptions = [
          { StatusID: 16, Status: "Recommended" },
          { StatusID: 17, Status: "Rejected" }
        ];
        this.showApproval = true;
      }
      else {
        newOptions = [];
        this.showApproval = false;
      }

      // Use Vue.set to ensure reactivity
      this.$set(this, 'ApprovalStatus', newOptions);

      // Also force update the component
      this.$forceUpdate();
    },

    checkReject(evt) {
      let id = parseInt(evt.target.value);
      let appStatus = _.filter(this.ApprovalStatus, { StatusID: id });
      if (appStatus) {
        if (appStatus.length > 0) {
          this.isReject = appStatus[0].ISReject;
          if (!this.isReject) {
            this.form.RejectReason = 0;
          }
        }
      }
    },
    goback() {
      //this.$router.back();
      this.$router.push({
        name: "Applications",
        params: {
          userDistrictID: this.$store.getters.getUserDistrict,
          userApprovalStatus: this.$store.getters.getAppStatus,
          userLoanType: 1,
        },
      });
    },
    calculateAge(birthDate) {
      birthDate = new Date(birthDate);
      let incrementDate = new Date(birthDate);
      // console.log(incrementDate);
      let today = new Date();
      let n = 0;
      while (incrementDate < today) {
        n++;
        incrementDate.setYear(incrementDate.getFullYear() + 1);
      }

      return n - 1;
    },
    convertDateFormat(inDate) {
      return Formatter.convertDateFormat(inDate);
    },
    onSubmit(evt) {
      evt.preventDefault();
      if (this.form.ApplicationStatus == this.ApplicationStatus) {
        return;
      }

      let promise = apis.UpdateApplicationStatus(this.form);

      promise
        .then((response) => {
          if (response.status == 200) {
            //Check the profile completion status
            this.alertText = response.body;
            this.variant = "success";
            this.showDismissibleAlert = true;
            this.isLoading = false;
            this.showButton = false;
          } else {
            this.alertText = response.body;

            this.variant = "warning";
            this.showDismissibleAlert = true;
            this.isLoading = false;
          }
        })
        .catch((err) => {
          this.alertText = err.message;
          this.showDismissibleAlert = true;
          this.variant = "danger";
        });
    },
    print() {
      window.print();
      //this.$htmlToPaper("printme");
    },
    edit() {
      this.$router.push("/LoginProfile");
    },
    getImgUrl(pic) {
      if (pic) {
        return (
          "https://aws.msobcfdc.in/S3BucketApril/" +
          this.UserID +
          "/" +
          pic
        );
      }
    },
    getImgUrl2(pic) {
      if (pic) {
        return (
          "https://aws.msobcfdc.in/S3BucketApril/msobcfdc_bsc/" + pic
        );
      }
    },
    EditField(fld) {
      if (this.editList[fld]) {
        switch (fld) {
          case "ePan":
            if (!this.validatePan) {
              this.alertText = "Please verify the PAN";
              this.variant = "warning";
              this.showDismissibleAlert = true;
              this.isLoading = false;
              return;
            }
            this.updateForm.Pan = this.personalDetails.PanCardNo;
            break;
          case "eAadhar":
            if (!this.validateAadhar) {
              this.alertText = "Please verify the Aadhar number";
              this.variant = "warning";
              this.showDismissibleAlert = true;
              this.isLoading = false;
              return;
            }
            this.updateForm.Aadhar = this.personalDetails.AdharNo;
            break;
          case "eRation":
            this.updateForm.RationCard = this.personalDetails.RationCardNo;
            break;
          case "eDOB":
            if (!this.validateAge) {
              this.alertText = "Age Criteria not fulfilled";
              this.variant = "warning";
              this.showDismissibleAlert = true;
              this.isLoading = false;
              return;
            }
            this.updateForm.DOB = Formatter.convertDateFormatYMD(this.DOB);
            this.updateForm.Age = this.age;
            break;
          case "eCaste":
            let casteName = _.filter(this.Caste, { CasteID: this.CasteID });
            this.personalDetails.CasteName = casteName[0].CasteName;
            this.updateForm.CasteID = casteName[0].CasteName;
            break;
          case "eAccount":
            this.updateForm.BankAccount =
              this.personalDetails.UserBankAccount.BankAccountNo;
            break;
        }
        this.updateForm.UserID = this.UserID;
        this.updateForm.LoanApplicationID = this.form.ApplicationID;
        this.updateForm.CreatedUser = this.$store.getters.loggedUser.UserID;

        let promiseA = apis.saveDMChanges(this.updateForm);

        promiseA
          .then((response) => {
            if (response.status == 200) {
              this.alertText = "Data Saved Successfully";
              this.variant = "success";
              this.showDismissibleAlert = true;
            } else {
              this.alertText = "Error while Updating Data, " + response.body;

              this.variant = "warning";
              this.showDismissibleAlert = true;
            }
          })
          .catch((err) => {
            this.alertText = "Error while Updating Data, " + err.message;
            this.showDismissibleAlert = true;
            this.variant = "danger";
          });
      } else {
        switch (fld) {
          case "eCaste":
            let casteid = _.filter(this.Caste, {
              CasteName: this.personalDetails.CasteName,
            });
            this.CasteID = casteid[0].CasteID;
            break;
        }
      }
      this.editList[fld] = !this.editList[fld];
    },
    CloseField(fld) {
      this.editList[fld] = !this.editList[fld];
    },
    getCaste() {
      let promiseA = apis.getCaste();

      promiseA
        .then((response) => {
          if (response.status == 200) {
            //let rspns = response.body;
            this.Caste = response.body;
          } else {
            this.alertText = "Unable to get caste List, " + response.body;

            this.variant = "warning";
            this.showDismissibleAlert = true;
          }
        })
        .catch((err) => {
          this.alertText = "Unable to get caste List, " + err.message;
          this.showDismissibleAlert = true;
          this.variant = "danger";
        });
    },
    printLoi() {
      this.PastLOI = false;
      this.$refs["loiModal"].show();
      // this.$router.push({
      //   name: "LoanLOIPrint",
      //   params: { ApplicationID: this.form.ApplicationID, Loantype: 1, UserID: this.UserID }
      // });
    },

    viewSanction() {
      var appNo = this.personalDetails &&
        this.personalDetails.LoanApplication &&
        this.personalDetails.LoanApplication[0]
          ? this.personalDetails.LoanApplication[0].LoanApplicationNo
          : "";
      this.$router.push({
        path: "/sanctionletters",
        query: { LoanApplicationNo: appNo }
      });
    },
    printLoiOld() {
      this.PastLOI = true;
      this.$refs["loiModal"].show();
      // this.$router.push({
      //   name: "LoanLOIPrint",
      //   params: { ApplicationID: this.form.ApplicationID, Loantype: 1, UserID: this.UserID }
      // });
    },
    extendLoi() {
      var appform = {
        ApplicationIDs: [this.form.ApplicationID],
        CreatedUser: this.$store.getters.loggedUser.UserID,
      };

      var t = this;
      this.$dialog
        .prompt(
          {
            title: "Confirm LOI Extension",
            body: "A New LOI will be issued for the selected Application, Do you want to Continue?",
          },
          {
            promptHelp: 'Provide Remarks and click "[+:okText]"',
            okText: "Extend LOI",
            cancelText: "Cancel",
            loader: false,
          }
        )
        .then(function (dialog) {
          if (dialog.data) {
            appform.remarks = dialog.data;
          } else {
            t.$dialog.alert("Please enter Remarks");
            return;
          }
          return apis.ExtendLoi(appform);
        })
        .then((response) => {
          if (response != undefined) {
            if (response.status == 200) {
              this.$dialog.alert(
                "New LOI Issued for the Selected Applications"
              );
              t.getApplicationsSub();
            } else {
              this.$dialog.alert("Unable to save changes");
            }
          }
        })
        .catch((err) => {
          if (err != false) {
            this.$dialog.alert("Error while saving data");
          }
        });

      // let promiseA = apis.ExtendLoi(appform);

      // promiseA
      //   .then(response => {
      //     if (response.status == 200) {
      //       alert("New LOI Issued");
      //       this.alertText = "New LOI Issued";
      //       this.variant = "Success";
      //       this.showDismissibleAlert = true;
      //     }
      //   })
      //   .catch(err => {
      //     this.alertText = "Unable to Save Changes, " + err.message;
      //     this.showDismissibleAlert = true;
      //     this.variant = "danger";
      //   });
    },

    // --- Role 0 Personal Details Edit Modal ---
    openPersonalEditModal() {
      const p = this.personalDetails;
      this.editPersonalForm.LoginID = this.UserID;
      this.editPersonalForm.FirstName = p.FirstName;
      this.editPersonalForm.MiddleName = p.MiddleName;
      this.editPersonalForm.LastName = p.LastName;
      this.editPersonalForm.Gender = p.Gender;
      this.editPersonalForm.MobileNo = p.MobileNo;
      this.editPersonalForm.EmailID = p.EmailID;
      this.editPersonalForm.AdharNo = p.AdharNo;
      this.editPersonalForm.PanCardNo = p.PanCardNo;
      this.editPersonalForm.MaritalStatus = p.MaritalStatus;
      this.editPersonalForm.Nationality = p.Nationality;
      this.editPersonalForm.Domiciled = p.Domiciled;
      this.editPersonalForm.FamilyIncome = p.FamilyIncome;
      this.editPersonalForm.RationCardNo = p.RationCardNo;
      this.editPersonalForm.RegistrationType = p.RegistrationType;
      // Set CasteID from caste list if available
      if (p.CasteName && this.Caste.length > 0) {
        let c = this.Caste.find(x => x.CasteName === p.CasteName);
        this.editPersonalForm.CasteID = c ? c.CasteID : "";
      }
      // DOB
      this.editPersonalDOB = this.DOB;
      this.modalAlert.show = false;
      this.$refs["editPersonalModal"].show();
    },

    savePersonalDetailsAdmin(bvModalEvt) {
      bvModalEvt.preventDefault();
      // Use the full loaded personalDetails as the base so all required server
      // fields (BoardID, UserReligionCaste GUIDs, etc.) are present, then overlay
      // only the fields the admin can edit in the modal.
      const personalPayload = JSON.parse(JSON.stringify(this.personalDetails));
      personalPayload.LoginID     = this.UserID;
      personalPayload.FirstName   = this.editPersonalForm.FirstName;
      personalPayload.MiddleName  = this.editPersonalForm.MiddleName;
      personalPayload.LastName    = this.editPersonalForm.LastName;
      personalPayload.Gender      = this.editPersonalForm.Gender;
      personalPayload.DOB         = Formatter.convertDateFormatYMD(this.editPersonalDOB);
      personalPayload.Age         = this.calculateAge(this.editPersonalDOB);
      personalPayload.MobileNo    = this.editPersonalForm.MobileNo;
      personalPayload.EmailID     = this.editPersonalForm.EmailID;
      personalPayload.AdharNo     = this.editPersonalForm.AdharNo;
      personalPayload.PanCardNo   = this.editPersonalForm.PanCardNo;
      personalPayload.MaritalStatus = this.editPersonalForm.MaritalStatus;
      personalPayload.Nationality = this.editPersonalForm.Nationality;
      personalPayload.Domiciled   = this.editPersonalForm.Domiciled;
      personalPayload.FamilyIncome = this.editPersonalForm.FamilyIncome;
      personalPayload.RationCardNo = this.editPersonalForm.RationCardNo;
      if (this.editPersonalForm.CasteID) personalPayload.CasteID = this.editPersonalForm.CasteID;
      personalPayload.LockProfile = false;
      // Only turn truly empty string GUID fields into null.
      // Zero GUIDs must stay as-is — the server uses "00000000…" as "no record" sentinel.
      const nullifyEmptyIds = (obj) => {
        if (!obj || typeof obj !== 'object' || Array.isArray(obj)) return;
        Object.keys(obj).forEach(k => {
          if (obj[k] === '' && (k.endsWith('ID') || k.endsWith('Id'))) { obj[k] = null; }
          else if (obj[k] && typeof obj[k] === 'object') { nullifyEmptyIds(obj[k]); }
        });
      };
      nullifyEmptyIds(personalPayload);
      // Re-assert LoginID after nullification
      personalPayload.LoginID = this.UserID;
      let promise = apis.saveUserRegistration(personalPayload);
      promise.then((response) => {
        if (response.status == 200) {
          // Update displayed data
          this.personalDetails.FirstName = this.editPersonalForm.FirstName;
          this.personalDetails.MiddleName = this.editPersonalForm.MiddleName;
          this.personalDetails.LastName = this.editPersonalForm.LastName;
          this.personalDetails.Gender = this.editPersonalForm.Gender;
          this.personalDetails.MobileNo = this.editPersonalForm.MobileNo;
          this.personalDetails.EmailID = this.editPersonalForm.EmailID;
          this.personalDetails.AdharNo = this.editPersonalForm.AdharNo;
          this.personalDetails.PanCardNo = this.editPersonalForm.PanCardNo;
          this.personalDetails.MaritalStatus = this.editPersonalForm.MaritalStatus;
          this.personalDetails.Nationality = this.editPersonalForm.Nationality;
          this.personalDetails.Domiciled = this.editPersonalForm.Domiciled;
          this.personalDetails.FamilyIncome = this.editPersonalForm.FamilyIncome;
          this.personalDetails.RationCardNo = this.editPersonalForm.RationCardNo;
          this.personalDetails.DOB = Formatter.convertDateFormat(this.editPersonalDOB);
          this.DOB = this.editPersonalDOB;
          if (this.editPersonalForm.CasteID && this.Caste.length > 0) {
            let c = this.Caste.find(x => x.CasteID === this.editPersonalForm.CasteID);
            if (c) this.personalDetails.CasteName = c.CasteName;
          }
          this.alertText = "Personal Details Updated Successfully";
          this.variant = "success";
          this.showDismissibleAlert = true;
          this.$refs["editPersonalModal"].hide();
        } else {
          this.modalAlert = { show: true, text: "Error updating personal details: " + this.getApiErrorText(response, "Unable to update personal details."), variant: "danger" };
        }
      }).catch((err) => {
        this.modalAlert = { show: true, text: "Error: " + this.getApiErrorText(err, "Unable to update personal details."), variant: "danger" };
      });
    },

    // --- Role 0 Lending Loan Edit Modal ---
    openLendingLoanEditModal() {
      const l = this.personalDetails.UserLendingLoanDetails;
      this.editLendingLoanForm.LoginID = this.UserID;
      this.editLendingLoanForm.UserLendingLoanDetails.OrganizationName = l.OrganizationName || "";
      this.editLendingLoanForm.UserLendingLoanDetails.OrganizationAddress = l.OrganizationAddress || "";
      this.editLendingLoanForm.UserLendingLoanDetails.ProductfromOrganization = l.ProductfromOrganization || "";
      this.editLendingLoanForm.UserLendingLoanDetails.AmountFromBank = l.AmountFromBank || "";
      this.editLendingLoanForm.UserLendingLoanDetails.LoanDistrict = l.LoanDistrict || "";
      this.editLendingLoanForm.UserLendingLoanDetails.BankName = l.BankName || "";
      this.editLendingLoanForm.UserLendingLoanDetails.Branch = l.Branch || "";
      this.modalAlert.show = false;
      this.$refs["editLendingLoanModal"].show();
    },

    saveLendingLoanAdmin(bvModalEvt) {
      bvModalEvt.preventDefault();
      let promise = apis.saveLendingLoanDetails(this.editLendingLoanForm);
      promise.then((response) => {
        if (response.status == 200) {
          // Update displayed data
          const l = this.editLendingLoanForm.UserLendingLoanDetails;
          this.personalDetails.UserLendingLoanDetails.OrganizationName = l.OrganizationName;
          this.personalDetails.UserLendingLoanDetails.OrganizationAddress = l.OrganizationAddress;
          this.personalDetails.UserLendingLoanDetails.ProductfromOrganization = l.ProductfromOrganization;
          this.personalDetails.UserLendingLoanDetails.AmountFromBank = l.AmountFromBank;
          this.personalDetails.UserLendingLoanDetails.BankName = l.BankName;
          this.personalDetails.UserLendingLoanDetails.Branch = l.Branch;
          this.alertText = "Lending Loan Details Updated Successfully";
          this.variant = "success";
          this.showDismissibleAlert = true;
          this.$refs["editLendingLoanModal"].hide();
        } else {
          this.modalAlert = { show: true, text: "Error updating lending loan details: " + this.getApiErrorText(response, "Unable to update lending loan details."), variant: "danger" };
        }
      }).catch((err) => {
        this.modalAlert = { show: true, text: "Error: " + this.getApiErrorText(err, "Unable to update lending loan details."), variant: "danger" };
      });
    },
  },

  mounted() {
    if (!this.UserID || this.UserID === '00000000-0000-0000-0000-000000000000') {
      this.$router.push({ name: 'Applications' });
      return;
    }
    this.editList = {
      eDOB: false,
      ePan: false,
      eAadhar: false,
      eRation: false,
      eCaste: false,
      eAccount: false,
      eAddress: false,
    };
    this.getCaste();
    var userinfo = this.$store.getters.loggedUser;
    this.RoleID = userinfo.RoleID;
    this.form.ApplicationStatus = this.ApplicationStatus;
    this.showApproval = false;

    let promise = apis.ReadApplicationStatusByRoleStatus({
      Role: userinfo.RoleID,
      Status: this.ApplicationStatus,
    });

    promise
      .then((response) => {
        // DBSC role only acts while the application is pending DBSC decision (status 2)
        if (this.RoleID == 3 && this.ApplicationStatus == 2) {
          this.setManualApprovalOptions();
          return;
        }
        if (response.status == 200) {
          const apiOptions = JSON.parse(response.body);

          if (apiOptions.length > 0) {
            this.$set(this, 'ApprovalStatus', apiOptions);
            this.showApproval = true;
          } else {
            this.setManualApprovalOptions();
          }
        } else {
          this.$set(this, 'ApprovalStatus', []);
          this.setManualApprovalOptions();
        }
      })
      .catch((err) => {
        this.$set(this, 'ApprovalStatus', []);
        this.alertText = "Error in Loading Application Staus Master";
        this.variant = "danger";
        this.showDismissibleAlert = true;
        this.setManualApprovalOptions();
      });

    this.form.UserID = userinfo.UserId;
    let promiseU = apis.ReadUserDetailByIndivisual(this.UserID); //Personal Details

    promiseU
      .then((response) => {
        if (response.status == 200) {
          //console.log(response.body);
          this.personalDetails = response.body;
          this.personalDetails.DOB = Formatter.convertDateFormat(
            response.body.DOB
          );
          this.DOB = Formatter.convertDateFormatYMD(response.body.DOB);
          for (var i = 0; i < response.body.LoanApplication.length; i++) {
            this.LoanType=response.body.LoanApplication[i].LoanType;
            if (response.body.LoanApplication[i].LoanType == 1 || response.body.LoanApplication[i].LoanType == 3) {
              this.personalDetails.LoanApplication[0].LoanApplicationNo =
                response.body.LoanApplication[i].LoanApplicationNo;
              this.form.ApplicationID =
                response.body.LoanApplication[i].LoanApplicationID;

              if (
                this.personalDetails.LoanApplication[0].ApprovalDoc != "" &&
                (this.ApplicationStatus == 3 || this.ApplicationStatus == 1)
              ) {
                this.ApprovalStatus.unshift({
                  StatusID: 19,
                  Status: "Re-Verified by DM",
                });
              }

              let promiseA = apis.ReadApprovalRemarks(this.form.ApplicationID);
              promiseA.then((response) => {
                if (response.status == 200) {
                  this.approvalRemarks = response.body;
                }
              });

              let promiseAL = apis.ReadApprovalRemarksLink(this.UserID);
              promiseAL.then((response) => {
                if (response.status == 200) {
                  this.approvalRemarksLink = response.body;
                  if (this.approvalRemarksLink.length > 0) {
                    this.showHistory = true;
                  }
                }
              });
            }
          }
          this.isLoading = false;
        } else {
          this.alertText = response.body;

          this.variant = "warning";
          this.showDismissibleAlert = true;
        }
      })
      .catch((err) => {
        this.alertText = err.message;
        this.showDismissibleAlert = true;
        this.variant = "danger";
      });

    let promiseR = apis.ReadRejectTypes();

    promiseR
      .then((response) => {
        if (response.status == 200) {
          this.RejectReasons = response.body;
        }
      })
      .catch((err) => {
        this.alertText = err.message;
        this.showDismissibleAlert = true;
        this.variant = "danger";
      });
  },
};
</script>

<style scoped>
table {
  font-family: arial, sans-serif;
  /* border-collapse: collapse; */
  width: 80%;
  margin-left: 10%;
}

td,
th {
  border: 1px solid #dddddd;
  text-align: left;
  padding: 6px;
}
.newfont {
  font-size: 0.875rem;
}

/* Print styles for mobile devices */
@media print {
  #printme .bv-example-row {
    display: block !important;
  }

  #printme .row {
    display: block !important;
    margin: 0 !important;
  }

  #printme .col-8,
  #printme .col-2 {
    width: 100% !important;
    max-width: 100% !important;
    flex: none !important;
    padding: 0 !important;
    margin: 0 !important;
  }

  #printme .col-2 {
    margin-top: 15px !important;
    text-align: right !important;
    page-break-inside: avoid;
  }

  #printme .col-2 img {
    max-width: 100px !important;
    height: auto !important;
    border: 1px solid #000 !important;
  }

  .profile-table {
    width: 100% !important;
    margin-left: 0 !important;
    font-size: 11px !important;
  }

  .reg-form-title {
    font-size: 14px !important;
  }

  /* Prevent page breaks inside important sections */
  .reg-form-box {
    page-break-inside: avoid;
  }
}

/* Mobile responsive styles for screen view */
@media screen and (max-width: 767px) {
  #printme .col-8 {
    margin-bottom: 10px;
  }

  #printme .col-2 {
    text-align: center;
  }

  #printme .col-2 img {
    max-width: 100px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Admin/ViewPersonalDetailsProfile.vue